<template>
  <div style="background: #fff;padding:10px 20px 20px 20px">
    <!-- <div class="record-container">
      <span>处理记录</span>
    </div> -->
    <div class="record-content">
      <el-table
        :data="opinions"
        :row-key="getRowKeys"
        style="width: 100%;overflow: auto;height:450px;"
        border
        header-cell-class-name="done-header-row"
        row-class-name="done-row"
        size="medium"
        :default-sort="{prop: 'createTime,completeTime', order: 'descending'}"
      >
        <el-table-column width="50" align="center" label="序号">
          <template slot-scope="scope">
            <span>{{opinions.length - scope.$index}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="taskName" label="审批节点" width="180" align="center"></el-table-column>

        <el-table-column prop="qualfiedNames" label="待审批人" width="200" align="center"></el-table-column>
        <el-table-column prop="auditorName" label="处理人" width="100" align="center"></el-table-column>

        <el-table-column align="center" label="处理情况" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.isRead==0 && scope.row.statusVal=='待审批'">待阅</span>
            <span v-if="scope.row.isRead==1 && scope.row.statusVal=='待审批'">已阅</span>
            <span v-if="scope.row.status!='backToStart' && scope.row.status!='reject' && scope.row.statusVal!='待审批'">{{scope.row.statusVal}}</span>
            <div v-if="(scope.row.status=='backToStart' || scope.row.status=='reject') && scope.row.statusVal!='待审批'">{{scope.row.statusVal | statusValFormat('a')}}</div>
            <span v-if="(scope.row.status=='backToStart' || scope.row.status=='reject') && scope.row.statusVal!='待审批'">{{scope.row.statusVal | statusValFormat('b')}}</span>
          </template>
        </el-table-column>

        <el-table-column label="处理意见" show-overflow-tooltip align="center">
          <template slot-scope="scope">
            <strong v-if="scope.row.statusVal!='征询'" style="display:block" v-html="formatOptinion(scope.row.opinion)"></strong>
            <strong v-if="scope.row.statusVal=='征询'"><span style=" white-space: pre-wrap;display:block" v-html="getOpinion(scope.row.opinion)"></span></strong>
            <div class="div_fj" v-if=" scope.row.files && scope.row.files.length!=0">
              <span class="title">附件：</span>
              <span style="float: left;" v-for="(item,index) in scope.row.files" :key="index">
                <span v-if="index==0">
                  <span class="files fj_right" @click="search(item)">{{item.name}}</span>
                  <br />
                </span>
                <span v-if="index!=0">
                  <span class="files fj_left" @click="search(item)">{{item.name}}</span>
                  <br />
                </span>
              </span>
            </div>
            <div class="div_fj" v-if=" scope.row.zfiles && scope.row.zfiles.length!=0">
              <span class="title">正文：</span>
              <span style="float: left;" v-for="(item,index) in scope.row.zfiles" :key="index">
                <span v-if="index==0">
                  <span class="files fj_right" @click="search(item)">{{item.name}}</span>
                  <br />
                </span>
                <span v-if="index!=0">
                  <span class="files fj_left" @click="search(item)">{{item.name}}</span>
                  <br />
                </span>
              </span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="completeTime" label="操作时间" width="160" align="center"></el-table-column>

        <el-table-column align="center" label="持续时间" width="100">
          <template slot-scope="scope">
            <span>{{formatTimeLag(scope.row)}}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column label="审批状态"  width="78" align="center">
            <template slot-scope="scope">
                <span v-if="scope.row.isRead==0">待阅</span>
                <span v-if="scope.row.isRead==1">已阅</span>
            </template>
        </el-table-column>-->
      </el-table>
    </div>
    <!-- 预览文件-->
    <FilePreview ref="filePreview" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import req from "@/request.js";
import FilePreview from "@/components/common/FilePreview.vue";
export default {
  name: "processRecord",
  components: { FilePreview },
  props: ["instId", "taskId", "referOpinion", "nodeType", "defId", "nodeId"],
  data() {
    return {
      src: "",
      data: { taskId: "", referOpinion: false },
      fileId: "",
      fileTree: "",
      // 获取row的key值
      getRowKeys(row) {
        return row.id;
      }
    };
  },
  watch: {
    instId: function(newVal, oldVal) {
      this.data.instId = newVal; //newVal即是instId
      this.data.taskId = this.taskId;
      this.data.referOpinion = this.referOpinion;
      this.data.nodeType = this.nodeType;
      this.data.defId = this.defId;
      this.data.nodeId = this.nodeId;
      this.$store.dispatch("storeProcess/getOpinionsById", this.data);
    }
  },
  computed: mapState({
    opinions: state => state.storeProcess.opinions
  }),
  filters:{
    statusValFormat(val,str){
      if(!val)return;
      val = val.toString();
        if(val.includes("回到本节点") || val.includes("重新审批")){
          return str == 'a'?val.split(' ')[0]:val.split(' ')[1]
        }
        return val;
    }
  },
  methods: {
    //查看附件
    formatTimeLag(row) {
      let endTimes = 0;
      if (!row.completeTime) {
        endTimes = new Date().getTime();
      } else {
        endTimes = new Date(row.completeTime).getTime();
      }
      let difference = endTimes - new Date(row.createTime).getTime();
      let r = "";
      ////计算出相差天数
      let days = Math.floor(difference / (24 * 3600 * 1000));
      //计算出小时数
      let leave1 = difference % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      let leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      if (days > 0) r += days + "天";
      if (hours > 0) r += hours + "小时";
      if (days > 0) {
        return r;
      }
      if (minutes > 0) r += minutes + "分钟";
      if (hours > 0) {
        return r;
      }
      if (seconds > 0) r += seconds + "秒";
      if (minutes == 0 && seconds >= 0) {
        return "小于1分钟";
      }
      //r.slice(0, r.indexOf('时'));
      return r;
    },
    search(item) {
      this.$refs.filePreview.preview(item);
    },
    getOpinion(opinion){
      return opinion;// ? Base64.decode(opinion).replace(/\n/g,'<br/>') : '';
    },
    formatOptinion(opinion){
      return opinion ? opinion.replace(/\n/g,'<br/>') : ''
    }
  },
  created() {
    if (this.instId) {
      this.data.instId = this.instId;
      this.$store.dispatch("storeProcess/getOpinionsById", this.data);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.div_fj {
  text-align: left;
  padding: 5px 0px;
}

.fj_left {
  padding: 0 15px;
  border-left: 1px solid #d8d8d8;
}

.fj_right {
  padding: 0 15px 0 0;
}

.title {
  display: block;
  color: #a2a2a2;
  font-weight: bold;
}

.record-container {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.record-container > span {
  border-left: 3px solid $--theme-color;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}

// .record-content {
//   padding: 20px 0;
// }

.files {
  cursor: pointer;
  font-size: 12px;
  color: #5eade6;
}

.files:hover {
  color: $--theme-color;
}

/deep/.el-table .cell.el-tooltip {
  min-width: 50px;
}

/deep/.el-table .cell {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
  padding-left: 10px;
  padding-right: 10px;
}
/deep/.el-table::before{
  height: 0;
}
</style>
